import React, {
  Fragment, useState, useEffect, useMemo
} from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Button, Drawer, Popconfirm, Popover, Select, Table, Tag, Tooltip,
} from 'antd';
import {
  DeleteOutlined, LoadingOutlined, SwapLeftOutlined, SwapOutlined, SwapRightOutlined, EditOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import ProductActions from '@Actions/productActions';
import SOActions from '@Actions/sales/soActions';
import { QUANTITY, DEFAULT_CUR_ROUND_OFF } from '@Apis/constants';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Helpers from '@Apis/helpers';
import SoActions from '@Actions/sales/soActions';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import H3Progress from '@Components/Common/H3Progress';
import RecentTransactions from '../../../../Inventory/ManageProducts/ViewProduct/RecentTransactions';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';
import documentUINamesConstant from '../../../../../apis/documentUINamesConstant';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';
import PRZModal from '../../../../Common/UI/PRZModal';
import './style.scss';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

const SOLines = ({
  soLines, selectedSO, updateBundleLines, visibleColumns, cfSalesOrderLine, updateBundleLinesLoading, user, deleteBundleLines, callback, deleteBundleLinesLoading, getProducts, products, MONEY, quickUpdateSO, isEditable, activityLogUpdater, setUpdateReserveDrawerOpen, selectedOrderLine, isEstimate, priceMasking, cfV2DocSalesEstimate, cfV2DocSalesOrder, isAMC, cfV2DocAnnualMaintenanceContract
}) => {
  const [openPopover, setOpenPopover] = useState(false);
  const [productsData, setProductsData] = useState([]);
  const [productSku, setProductSku] = useState(null);
  const [skuData, setSkuData] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [quantity, setQuantity] = useState(null);
  const [showPRZModal, setShowPRZModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  useEffect(() => {
    getProducts(null, selectedSO?.tenant_id, '', '', '', selectedSO?.tenant_department_id, '', 'SERVICE,STORABLE,NON_STORABLE', '', true);
  }, [selectedSO]);

  useEffect(() => {
    if (products?.result?.products) {
      setProductsData(products?.result?.products);
    }
  }, [products]);

  const { isDataMaskingPolicyEnable, isHideSellingPrice } = priceMasking;

  const bundleListColumns = [
    {
      title: 'Product',
      render: (record) => (
        <Fragment>
          <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`} target="_blank">
            {record?.product_sku_info?.internal_sku_code}
          </Link>
          <H3Text text={`${record?.product_sku_info?.ref_product_code ? `${record?.product_sku_info?.ref_product_code} - ` : ''}${record?.product_sku_name}`?.trim()} className="" />
          {/* <H3Text text={record.remark} className="table-subscript" /> */}
          <div
            dangerouslySetInnerHTML={{ __html: record?.remark }}
            className="table-subscript"
            style={{
              width: '200xp',
              whiteSpace: 'pre-wrap',
            }}
          />
        </Fragment>
      ),
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      render: (text, record) => {
        const uqc = record?.uom_info?.[0]?.uqc?.toProperCase() || '';
        const precision = record?.uom_info?.[0]?.precision;
        return (
          <Fragment>
            {`${QUANTITY(Math.abs(record?.quantity), precision)} ${uqc}`}
            <div className="so-line__progress-bar">
              <div>
                <span>
                  {`${QUANTITY(Math.abs(record?.invoice_gen_quantity), precision)} / ${QUANTITY(Math.abs(record?.quantity), precision)} ${isAMC ? 'Consumed' : 'Invoiced'}`}
                </span>
                <H3Progress
                  percent={parseInt((Math.abs(record?.invoice_gen_quantity ?? 0) / (record?.quantity)) * 100)}
                  barWidth="80px"
                />
              </div>
            </div>
            {!isEstimate && (<div className="so-line__progress-bar">
              <div>
                <span>
                  {`${QUANTITY(Math.abs(record?.reserved_quantity), precision)} / ${QUANTITY(Math.abs(Number(record?.quantity) - Number(record?.invoice_gen_quantity)), precision)} Reserved`}
                </span>
                <H3Progress
                  percent={parseInt((Math.abs(record?.reserved_quantity ?? 0) / (record?.quantity)) * 100)}
                  barWidth="80px"
                />
              </div>
              <div
                className="so_line__reserve-button"
                onClick={() => {
                  setUpdateReserveDrawerOpen(true);
                  selectedOrderLine(record);
                }}
              >
                <EditOutlined />
              </div>
            </div>)}
          </Fragment>
        );
      },
    },
  ];
  if (selectedSO?.shopify_order_number) {
    bundleListColumns.push({
      title: '',
      width: '70px',
      render: (text, record) => {
        const logger1 = selectedSO?.sales_order_lines.find((line) => line.order_line_id === record?.parent_line_id);
        const bdlproducts = logger1?.bundle_products;
        const tenantProductIds = bdlproducts.map((item) => item.tenant_product_id);
        return (
          (!record.is_bundle_editable && !record?.isBundleFulfilled) ? (
            <div className="add-shopify-bundle-product__actions">
              <Popover
                overlayClassName="custom_popover"
                content={(
                  <div>
                    <div style={{ width: '250px' }} className="add-shopify-bundle-product">
                      <div>
                        <H3Text text="Select a New Replacement Product" className="orgFormLabel" />
                        <PRZSelect
                          allowClear
                          onClear={() => { setProductSku(null); setSkuData(null); setFormSubmitted(false); }}
                          value={productSku}
                          filterOption={false}
                          disabled={deleteBundleLinesLoading || updateBundleLinesLoading}
                          onChange={(value) => {
                            setProductSku(value);
                            setSkuData(productsData.find((item) => item?.product_sku_id === value));
                            getProducts(null, selectedSO?.tenant_id, '', '', '', selectedSO?.tenant_department_id, '', 'SERVICE,STORABLE,NON_STORABLE', '', true);
                          }}
                          showSearch
                          onSearch={(input) => {
                            getProducts(input, selectedSO?.tenant_id, '', '', '', selectedSO?.tenant_department_id, '', 'SERVICE,STORABLE,NON_STORABLE', '', true);
                          }}
                          placeholder="Select a products"
                          showError={formSubmitted && productSku === null}
                          errorName="Please select products"
                          errorClassName="input-error"
                        >

                          {productsData?.filter((product) => !tenantProductIds.includes(product.tenant_product_id))
                            ?.map((item) => (
                              <Option key={item?.product_sku_id} value={item?.product_sku_id}>
                                <div className="product-filter__option">
                                  <H3Text
                                    text={`#${item?.product_info?.internal_sku_code || item?.product_info?.ref_product_code} ${item?.product_info?.product_sku_name}`}
                                    className="product-filter__option-text"
                                  />
                                  <div style={{ display: 'flex', marginTop: '5px' }}>
                                    {['SERVICE'].includes(item?.product_info?.product_type)
                                      && <H3Text text={item?.product_info?.product_type} className="status-tag" />}
                                    <div
                                      className="status-tag"
                                      style={{ backgroundColor: Number(item?.available_qty) <= 0 ? 'red' : '' }}
                                    >
                                      {`${item?.available_qty || '0'} ${item?.product_info?.uom_info?.uqc?.toProperCase()}`}
                                    </div>
                                  </div>
                                </div>
                              </Option>
                            ))}
                        </PRZSelect>
                      </div>
                      <div style={{ marginTop: '10px', display: 'flex' }}>
                        <Button
                          type="primary"
                          size="small"
                          buttonType={defaultButtonTypes.BLUE_ROUNDED}
                          onClick={() => {
                            setFormSubmitted(true);
                            const logger = selectedSO?.sales_order_lines.find((line) => line.order_line_id === record?.parent_line_id);
                            const product = logger?.bundle_products;
                            const updatedOrderArray = product?.filter((order) => order.order_line_id !== record?.order_line_id);
                            const newObject = {
                              // order_line_id: null,
                              order_id: record?.order_id,
                              tenant_product_id: skuData?.tenant_product_id,
                              offer_price: record?.offer_price,
                              unit_price: record?.unit_price,
                              discount_percent: record?.discount_percent,
                              tax_id: skuData?.tax_info?.[0]?.tax_id || skuData?.tax_info?.tax_id,
                              quantity: record?.quantity,
                              remarks: record?.remarks,
                              product_sku_name: skuData?.product_info?.product_sku_name,
                              uom_id: skuData?.uom_id,
                              uom_info: [skuData?.uom_info],
                              tax_group_info: skuData?.tax_info,
                              shopify_line_id: record?.shopify_line_id,
                              shopify_line_object: record?.shopify_line_object,
                              line_discount_percentage: record?.line_discount_percentage,
                              is_bundle_editable: false,
                              parent_line_id: record?.parent_line_id,
                            };
                            updatedOrderArray.push(newObject);
                            const updateBundlepayload = [{
                              order_line_id: record?.parent_line_id,
                              order_id: record?.order_id,
                              bundle_lines: updatedOrderArray,
                              shopify_order_id: selectedSO?.shopify_order_id,
                              org_id: selectedSO?.org_id,

                            }];
                            if (productSku !== null && skuData !== null) { updateBundleLines(updateBundlepayload, () => { callback(); }); }
                          }}
                          customClass="product-submit"
                          loading={updateBundleLinesLoading || deleteBundleLinesLoading}
                          disabled={updateBundleLinesLoading || deleteBundleLinesLoading}
                        >
                          Swap Product
                        </Button>
                      </div>
                    </div>

                  </div>
                )}
                trigger="click"
              >
                <div
                  className="add-shopify-bundle-product__action"
                >
                  {updateBundleLinesLoading ? <LoadingOutlined /> : <SwapOutlined />}
                </div>
              </Popover>
              <Popconfirm
                title="Delete the product from the bundle "
                description="Are you sure to delete this product?"
                onConfirm={() => {
                  const deletePayload = {
                    order_line_id: record?.order_line_id,
                    parent_line_id: record?.parent_line_id,
                    shopify_order_id: selectedSO?.shopify_order_id,
                    org_id: selectedSO?.org_id,
                  };
                  deleteBundleLines(deletePayload, () => { callback(); });
                }}
                okText="Yes"
                cancelText="No"
              >
                <div className="add-shopify-bundle-product__action">
                  {deleteBundleLinesLoading ? <LoadingOutlined /> : <DeleteOutlined />}
                </div>
              </Popconfirm>
            </div>
          ) : (<div style={{ display: 'flex', justifyContent: 'center' }}>-</div>)

        );
      }
      ,
    });
  }

  const getSalesOrderLinesColumns = () => {
    const salesOrderLinesColumns = [
      {
        title: '',
        render: (record) => (
          <div
            className="mobile-list__item"
          >
            <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`} target="_blank">

              <div style={{ display: 'flex' }}>
                <H3Text text={`#${record?.product_sku_info?.product_sku_name}`} className="mobile-list__item-number" />
              </div>
              <div style={{ marginBottom: '5px' }}>
                {record?.adjustment_entity_type?.replaceAll('_', ' ') === 'OUTWARD'
                  && (
                    <div className="ia-type-tag" style={{ backgroundColor: '#f15353' }}>
                      <SwapRightOutlined />
                      <H3Text text="Outgoing" className="" />
                    </div>
                  )}
                {record?.adjustment_entity_type?.replaceAll('_', ' ') === 'INWARDS'
                  && (
                    <div className="ia-type-tag" style={{ backgroundColor: '#2fbc6e' }}>
                      <SwapLeftOutlined />
                      <H3Text text="Incoming" className="" />
                    </div>
                  )}
              </div>
              <div className="mobile-list__item-info">
                <Tag color="processing">
                  {QUANTITY(record?.quantity, record?.uom_info?.[0]?.precision)}
                  {' '}
                  {record?.uom_info?.[0]?.uqc?.toProperCase() || ''}
                </Tag>
              </div>
              <div className="flex-align-space-between">
                <H3Text text={`${MONEY((record.unit_price), selectedSO?.org_currency_info?.currency_code)} Per Pcs`} className="mobile-list__item-info" />
                <H3Text text={MONEY((record.line_total_price || '0'), selectedSO?.org_currency_info?.currency_code)} className="mobile-list__item-info" />
              </div>
              <H3Text text={`Tax@ ${record.tax_info?.[0]?.tax_value}%`} className="mobile-list__item-info" />
            </Link>
          </div>

        ),
        responsive: ['xs'],
      },
      {
        title: 'Product',
        fixed: 'left',
        render: (record) => {
          const tenantProductIds = record?.bundle_products.map((item) => item.tenant_product_id);
          return (
            <div style={{ maxWidth: '280px', minWidth: '180px' }}>
              <div onClick={() => {
                setShowPRZModal(true);
                setSelectedDocumentId(record?.product_sku_info?.product_sku_id);
              }}>
                <a>
                  {`#${record?.product_sku_info?.internal_sku_code}`}
                </a>
              </div>
              <div className="flex-align-c" style={{ gap: '10px' }}>
                <H3Text text={`${record?.product_sku_info?.ref_product_code ? `${record?.product_sku_info?.ref_product_code} - ` : ''}${record?.product_sku_name}`?.trim()} className="" />
                <div style={{ marginLeft: 'auto', width: '20px' }}>
                  {Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.CREATE, user) && (
                    <RecentTransactions
                      tenantId={selectedSO?.tenant_id}
                      productSkuId={record?.product_sku_info?.product_sku_id}
                      internalSkuCode={record?.product_sku_info?.internal_sku_code}
                      refProductCode={record?.product_sku_info?.ref_product_code}
                      productSkuName={record?.product_sku_name}
                      costumerID={selectedSO?.customer_id}
                      TransactionType="SALES_ORDER"
                    />
                  )}
                </div>
              </div>
              {record?.product_category_info?.category_path?.length > 0 && (
                <ProductCategoryLabel
                  categoryPath={record?.product_category_info?.category_path}
                  categoryName={record?.product_category_info?.category_path?.at(-1)}
                  containerStyle={{
                    width: 'fit-content',
                  }}
                />
              )}
              <div
                dangerouslySetInnerHTML={{ __html: record?.remarks }}
                className="table-subscript"
                style={{
                  width: '200xp',
                  whiteSpace: 'pre-wrap',
                }}
              />
              <div style={{
                fontSize: '10px', display: 'flex',
              }}
              >
                <H3Text text={record?.product_sku_info?.product_type === 'SERVICE' ? 'SAC' : 'HSN'} />
                &nbsp;
                {record?.hsn_code && <H3Text text={record?.hsn_code} />}

              </div>
              {(record?.product_sku_info?.product_type === 'BUNDLE') && <H3Text text="Bundle" className="table-subscript table-subscript-tag" />}
              {record?.is_deleted && <H3Text text="Deleted" className="so__deleted-transaction" />}
              {(selectedSO?.shopify_order_number && record.is_bundle_editable && (Number(record?.refund_quantity) + Number(record?.fulfilled_quantity)) < Number(record?.quantity)) ? (
                <Fragment>
                  <Drawer
                    onClose={() => setOpenPopover(!openPopover)}
                    open={openPopover}
                    width="320px"
                    destroyOnClose
                  >
                    <div>
                      <div className="custom-drawer__header-wrapper">
                        <div className="custom-drawer__header" style={{ width: '270px' }}>
                          <H3Text text="Add New Item to Bundle" className="custom-drawer__title" />
                          <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showNewRoleModal: false })} />
                        </div>
                      </div>
                      <div className="add-shopify-bundle-product">
                        <H3Text text="Select a New Product" className="orgFormLabel" />
                        <div>
                          <PRZSelect
                            required
                            allowClear
                            onClear={() => {
                              setProductSku(null);
                              setSkuData(null);
                              setFormSubmitted(false);
                            }}
                            value={productSku}
                            filterOption={false}
                            disabled={deleteBundleLinesLoading || updateBundleLinesLoading}
                            onChange={(value) => {
                              setProductSku(value);
                              setSkuData(productsData.find((item) => item?.product_sku_id === value));
                              getProducts(null, selectedSO?.tenant_id, '', '', '', selectedSO?.tenant_department_id, '', 'SERVICE,STORABLE,NON_STORABLE', '', true);
                            }}
                            showSearch
                            onSearch={(input) => {
                              getProducts(input, selectedSO?.tenant_id, '', '', '', selectedSO?.tenant_department_id, '', 'SERVICE,STORABLE,NON_STORABLE', '', true);
                            }}
                            placeholder="Select a product"
                            showError={formSubmitted && productSku === null}
                            errorName="Please select products"
                            errorClassName="input-error"
                          >
                            {productsData?.filter((product) => !tenantProductIds.includes(product.tenant_product_id))?.map((item) => (
                              <Option key={item?.product_sku_id} value={item?.product_sku_id}>
                                <div className="product-filter__option">
                                  <H3Text
                                    text={`#${item?.product_info?.internal_sku_code || item?.product_info?.ref_product_code} ${item?.product_info?.product_sku_name}`}
                                    className="product-filter__option-text"
                                  />
                                  <div style={{ display: 'flex', marginTop: '5px' }}>
                                    {['SERVICE'].includes(item?.product_info?.product_type)
                                      && (
                                        <H3Text
                                          text={item?.product_info?.product_type}
                                          className="status-tag"
                                        />
                                      )}
                                    <div
                                      className="status-tag"
                                      style={{ backgroundColor: Number(item?.available_qty) <= 0 ? 'red' : '' }}
                                    >
                                      {`${item?.available_qty || '0'} ${item?.product_info?.uom_info?.uqc?.toProperCase()}`}
                                    </div>
                                  </div>
                                </div>
                              </Option>
                            ))}
                          </PRZSelect>
                        </div>
                        <div style={{ marginTop: '15px' }}>
                          <H3FormInput
                            name="Quantity"
                            type="text"
                            containerClassName="orgInputContainer"
                            labelClassName="orgFormLabel"
                            inputClassName="orgFormInput"
                            placeholder=""
                            onChange={(event) => setQuantity(event.target.value)}
                            disabled={deleteBundleLinesLoading || updateBundleLinesLoading}
                            value={quantity}
                            label="Quantity"
                            maxlength="100"
                            required
                            showError={formSubmitted && quantity === null}
                          />
                        </div>
                        <div style={{ marginTop: '20px', display: 'flex' }}>
                          <Button
                            type="primary"
                            onClick={() => {
                              setFormSubmitted(true);
                              const logger = selectedSO?.sales_order_lines.find((line) => line.order_line_id === record?.order_line_id);
                              const product = logger?.bundle_products;
                              const newObject = {
                                // order_line_id: null,
                                order_id: record?.order_id,
                                tenant_product_id: skuData?.tenant_product_id,
                                offer_price: 0,
                                unit_price: 0,
                                discount_percent: 0,
                                tax_id: skuData?.tax_info?.tax_id,
                                quantity: Number(quantity),
                                remarks: '',
                                product_sku_name: skuData?.product_info?.product_sku_name,
                                uom_id: skuData?.uom_id,
                                uom_info: [skuData?.uom_info],
                                tax_info: skuData?.tax_info,
                                shopify_line_id: logger?.shopify_line_id,
                                shopify_line_object: logger?.shopify_line_object,
                                line_discount_percentage: 0,
                                is_bundle_editable: false,
                                parent_line_id: record?.order_line_id,
                              };
                              product.push(newObject);
                              const updateBundlepayload = [{
                                order_line_id: record?.order_line_id,
                                order_id: record?.order_id,
                                bundle_lines: product,
                                shopify_order_id: selectedSO?.shopify_order_id,
                                org_id: selectedSO?.org_id,

                              }];

                              if (productSku !== null && skuData !== null && quantity !== null) {
                                updateBundleLines(updateBundlepayload, () => {
                                  callback();
                                });
                              }
                            }}
                            customClass="product-submit "
                            loading={updateBundleLinesLoading || deleteBundleLinesLoading}
                            disabled={updateBundleLinesLoading || deleteBundleLinesLoading}
                            size="small"
                          >
                            Add Product
                          </Button>
                          <Button
                            style={{ marginLeft: '10px' }}
                            type
                            onClick={() => {
                              setOpenPopover(!openPopover);
                              setProductSku(null);
                              setSkuData(null);
                              setFormSubmitted(false);
                              setQuantity(null);
                            }}
                            customClass="product-submit"
                            disabled={updateBundleLinesLoading || deleteBundleLinesLoading}
                            size="small"
                          >
                            Cancel
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Drawer>
                  <H3Text text="+ Add Item to Bundle" className="add__product_SO_lines" onClick={() => setOpenPopover(!openPopover)} />
                </Fragment>
              ) : ''}
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        visible: visibleColumns?.SKU?.visible,
      },
      {
        title: 'Quantity',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => {
          const uqc = record?.uom_info?.[0]?.uqc?.toProperCase() || '';
          const precision = record?.uom_info?.[0]?.precision;
          return (
            <Fragment>
              <div>
                <div>
                  {`${QUANTITY(Math.abs(record?.quantity), precision)} ${uqc}`}
                </div>
              </div>

              {!record?.bundle_products?.length && (
                <Fragment>
                  <div className="so-line__progress-bar">
                    <div>
                      <span>
                        {`${QUANTITY(Math.abs(record?.invoice_gen_quantity), precision)} / ${QUANTITY(Math.abs(record?.quantity), precision)} ${isAMC ? 'Consumed' : 'Invoiced'}`}
                      </span>
                      <H3Progress
                        percent={parseInt((Math.abs(record?.invoice_gen_quantity ?? 0) / (record?.quantity)) * 100)}
                        barWidth="80px"
                      />
                    </div>
                  </div>
                  {!isEstimate && Math.abs(record?.invoice_gen_quantity) < Math.abs(record?.quantity) && (
                    <div className="so-line__progress-bar">
                      <div>
                        <span>
                          {`${QUANTITY(Math.abs(record?.reserved_quantity), precision)} / ${QUANTITY(Math.abs(Number(record?.quantity) - Number(record?.invoice_gen_quantity)), precision)} Reserved`}
                        </span>
                        <H3Progress
                          percent={parseInt((Math.abs(record?.reserved_quantity ?? 0) / (record?.quantity)) * 100)}
                          barWidth="80px"
                        />
                      </div>
                      <div
                        className="so_line__reserve-button"
                        onClick={() => {
                          setUpdateReserveDrawerOpen(true);
                          selectedOrderLine(record);
                        }}
                      >
                        <EditOutlined />
                      </div>
                    </div>
                  )}
                </Fragment>
              )}
            </Fragment>
          );
        },
        visible: visibleColumns?.QTY?.visible,
      },
      {
        title: 'Rate',
        responsive: ['sm', 'md', 'lg', 'xxl'],

        render: (record) => ((isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view rate"} /> : MONEY((record?.unit_price), selectedSO?.org_currency_info?.currency_code)),
        visible: visibleColumns?.PRICE?.visible,
      },
      {
        title: 'Tax',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => `${record?.tax_group_info?.tax_value}%`,
        visible: visibleColumns?.TAX?.visible,
      },
      {
        title: 'Discount',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => (
          <Fragment>
            {
              Number(record?.line_discount_percentage) > 0 ? (
                <Fragment>
                  {record?.is_discount_in_percent ? `${Number(record?.line_discount_percentage).toPrecision(DEFAULT_CUR_ROUND_OFF) || '0'}%` : MONEY(record?.line_discount_amount, selectedSO?.org_currency_info?.currency_code)}
                </Fragment>
              ) : '-'
            }
          </Fragment>
        ),
        visible: visibleColumns?.DISCOUNT?.visible,
      },
      {
        title: 'Total',
        fixed: 'right',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => ((isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view rate"} /> : MONEY(((record?.line_total_price || '0')), selectedSO?.org_currency_info?.currency_code)),
        visible: visibleColumns?.TOTAL?.visible,
      },
    ];
    if (selectedSO?.shopify_order_id) {
      salesOrderLinesColumns.splice(4, 0, {
        title: 'Fulfilled',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => <div style={{ whiteSpace: 'nowrap' }}>{`${QUANTITY(item?.fulfilled_quantity, item?.uom_info?.[0]?.precision)} ${item?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>,
        visible: true,
      });
      salesOrderLinesColumns.splice(5, 0, {
        title: 'Refunded',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => <div style={{ whiteSpace: 'nowrap' }}>{`${QUANTITY(item?.refund_quantity, item?.uom_info?.[0]?.precision)} ${item?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>,
        visible: true,
      });
    }
    if (selectedSO?.shopify_order_id && selectedSO?.shopify_cancelled_at) {
      salesOrderLinesColumns.splice(5, 0, {
        title: 'Cancelled',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => <div style={{ whiteSpace: 'nowrap' }}>{`${QUANTITY(item?.quantity - item?.fulfilled_quantity, item?.uom_info?.[0]?.precision)} ${item?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>,
        visible: true,
      });
    }

    const cfV2Doc = window.location.href.includes('/estimate') ? cfV2DocSalesEstimate : (selectedSO?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ? cfV2DocAnnualMaintenanceContract : cfV2DocSalesOrder);

    if (cfSalesOrderLine?.length) {
      salesOrderLinesColumns.splice(3, 0, ...CustomFieldHelpers.renderCustomLineColumns(false, cfSalesOrderLine, visibleColumns, null, '', quickUpdateSO, 'order_line_id', isEditable, activityLogUpdater, { order_id: selectedSO?.order_id }, '', '', false, cfV2Doc));
    }

    return salesOrderLinesColumns?.filter((item) => item.visible) || [];
  };

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  return (
    <Fragment>
      <div className="view__so-lines">
        <Table
          bordered
          loading={updateBundleLinesLoading || deleteBundleLinesLoading}
          showHeader
          title={() => `${isEstimate ? documentUINames.estimateUIName : documentUINames.salesOrderUIName} Items (${soLines?.length})`}
          size="small"
          columns={getSalesOrderLinesColumns() || []}
          dataSource={soLines || []}
          pagination={false}
          scroll={{ x: 'max-content' }}
          expandable={{
            rowExpandable: (record) => record?.bundle_products?.length,
            defaultExpandAllRows: true,
            expandedRowRender: (record) => (
              <div className="view-bundle__inner-table">
                <Table
                  bordered
                  showHeader
                  size="small"
                  loading={updateBundleLinesLoading || deleteBundleLinesLoading}
                  scroll="scroll"
                  columns={bundleListColumns}
                  dataSource={record?.bundle_products?.map((item) => ({
                    ...item,
                    bundle_quantity: parseFloat(item?.quantity || '0'),
                    isBundleFulfilled: (Number(record?.refund_quantity) + Number(record?.fulfilled_quantity)) >= Number(record?.quantity),
                  }))}
                  pagination={false}
                />
              </div>
            ),
          }}
          rowClassName={(record) => (record?.is_deleted ? 'so_line-deleted-row' : '')}
        />
      </div>

      <PRZModal
        isOpen={showPRZModal}
        onClose={() => {
          setShowPRZModal(false);
          setSelectedDocumentId(null);
        }}
        entityType="product"
        documentId={selectedDocumentId}
      />
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, SOReducers, ProductReducers, CFV2Reducers }) => ({
  updateBundleLinesLoading: SOReducers.updateBundleLinesLoading,
  deleteBundleLinesLoading: SOReducers.deleteBundleLinesLoading,
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  products: ProductReducers.products,
  priceMasking: UserReducers.priceMasking,
  cfV2DocSalesOrder: CFV2Reducers.cfV2DocSalesOrder,
  cfV2DocSalesEstimate: CFV2Reducers.cfV2DocSalesEstimate,
  cfV2DocAnnualMaintenanceContract: CFV2Reducers.cfV2DocAnnualMaintenanceContract,
});

const mapDispatchToProps = (dispatch) => ({
  updateBundleLines: (payload, callback) => dispatch(SOActions.updateBundleLines(payload, callback)),
  deleteBundleLines: (payload, callback) => dispatch(SOActions.deleteBundleLines(payload, callback)),
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct)),
  quickUpdateSO: (payload, callback, rollback) => dispatch(SoActions.quickUpdateSO(payload, callback, rollback)),
});

SOLines.propTypes = {
  soLines: PropTypes.any,
  selectedSO: PropTypes.any,
  selectedPurchaseOrder: PropTypes.any,
  callback: PropTypes.func,
  updateBundleLines: PropTypes.func,
  deleteBundleLines: PropTypes.func,
  updateBundleLinesLoading: PropTypes.bool,
  deleteBundleLinesLoading: PropTypes.bool,
  user: PropTypes.any,
  getProducts: PropTypes.func,
  products: PropTypes.any,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SOLines));
